function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { theme } from '@react-spectrum/theme-default';
import { themeSpectrumClassesCommon } from "../../theme/theme-spectrum/index.js";
export { useStyleProps, baseStyleProps, viewStyleProps } from '@react-spectrum/utils';
var global = theme.global,
  light = theme.light,
  dark = theme.dark,
  medium = theme.medium,
  large = theme.large;

/**
 * Extend light + dark theme variables with DH defaults.
 *
 * A theme is just a mapped collection of css class names that are generated
 * from a collection of css modules.
 *
 * e.g.
 * {
 *   global: {
 *     spectrum: 'spectrum_9e130c',
 *     'spectrum--medium': 'spectrum--medium_9e130c',
 *     'spectrum--large': 'spectrum--large_9e130c',
 *     'spectrum--darkest': 'spectrum--darkest_9e130c',
 *     'spectrum--dark': 'spectrum--dark_9e130c',
 *     'spectrum--light': 'spectrum--light_9e130c',
 *     'spectrum--lightest': 'spectrum--lightest_9e130c',
 *   },
 *   light: {
 *     'spectrum--light': 'spectrum--light_a40724',
 *     'dh-spectrum-theme--light': '_dh-spectrum-theme--light_1hblg_22',
 *   },
 *   dark: {
 *     'spectrum--darkest': 'spectrum--darkest_256eeb',
 *     'dh-spectrum-theme--dark': '_dh-spectrum-theme--dark_f7kge_22',
 *   },
 *   medium: {
 *     'spectrum--medium': 'spectrum--medium_4b172c',
 *   },
 *   large: {
 *     'spectrum--large': 'spectrum--large_c40598',
 *   },
 * }
 */
/* eslint-disable import/prefer-default-export */
export var themeDHDefault = {
  global,
  light: _objectSpread(_objectSpread({}, light), themeSpectrumClassesCommon),
  dark: _objectSpread(_objectSpread({}, dark), themeSpectrumClassesCommon),
  // scales
  medium,
  large
};
//# sourceMappingURL=themeUtils.js.map